// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"67fa87a9","181":"a464c14f","787":"4deb1f95"}[chunkId] + ".chunk.js";
};